import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';
import { CompanyModel } from 'app/models/company-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';


@Component({
  selector: 'app-admin-company',
  templateUrl: './admin-company.page.html',
  styleUrls: ['./admin-company.page.scss'],
})
export class AdminCompanyPage implements OnInit {
  
  companies: CompanyModel[] = [];
  displayedColumns: string[] = ['id', 'name', 'domain'];
  dataSource = new MatTableDataSource<CompanyModel>;


  constructor(
    private dialog: MatDialog,
    private restService: RestService,
    public appService: AppService) { }

  ngOnInit() {
    this.searchCompanies();
  }

  openNew() {
    this.openDetails();
  }

  openDetails(company?: CompanyModel) {
    let dialogRef = this.dialog.open(CompanyModalContent, {
      panelClass: 'responsive-dialog',
      data: { companies: this.companies, company: company }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchCompanies());
  }

  searchCompanies(){
    this.restService.searchCompanies().subscribe(result => {
      Log.debug('getCompanies', result);
      this.companies = result;
      this.dataSource = new MatTableDataSource(result);
    });
  }

}


@Component({
  selector: 'app-company-modal-content',
  templateUrl: './company-modal.component.html',
  styleUrls: ['./company-modal.component.scss']
})
export class CompanyModalContent implements OnInit {

  isNew:boolean;
  form!: FormGroup;
  literalkeys:string[] = [];
  imagePreview: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;

  constructor(private fb: FormBuilder,
              private restService: RestService,
              public appService: AppService,
              private dialogRef: MatDialogRef<CompanyModalContent>,
                @Inject(MAT_DIALOG_DATA) public data: { companies: CompanyModel[], company: CompanyModel}) {}


  ngOnInit(){
    this.isNew = this.data?.company == null;
    const company:CompanyModel = this.data?.company ?? {} as CompanyModel;
    this.initForm(company);    
  }

  initForm(company: CompanyModel): void {
      this.form = this.fb.group({
        id: [company.id ?? null],
        name: [company.name ?? '', [Validators.required]],
        domain: [company.domain ?? '', [Validators.required]],
        reserveDomain: [company.reserveDomain ?? '', [Validators.required]],
        primaryEmail: [company.primaryEmail ?? '', [Validators.required]],
        secondaryEmail: [company.secondaryEmail ?? '', []],
        phoneNumberFrom: [company.phoneNumberFrom ?? '', []],
        brandingColor: [company.brandingColor ?? '', [Validators.required]],
        imageName: []
      });
  }

  close() {
      this.dialogRef.close();
  }

  confirm() {
    const company:CompanyModel = this.prepareCompany();
    Log.debug('guardarCompany', {company});
    this.update(company);
  }
  
  update(company:CompanyModel){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    if (this.form.invalid) return;


    if (this.isNew) {
      this.restService.createCompany(company).subscribe({
        next: res => {
          if(this.selectedFile){
            this.onUpload();
          }else{
            this.dialogRef.close({ updated: true }); 
            this.appService.showSuccessToast(Constants.MSG_SUCCESS);
          }
        }
      });
    } else {
      this.restService.putCompany(company).subscribe({
        next: res => {
          if(this.selectedFile){
            this.onUpload();
          }else{
            this.dialogRef.close({ updated: true }); 
            this.appService.showSuccessToast(Constants.MSG_SUCCESS);
          }
        }
      });
    }

  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {

      this.selectedFile = input.files[0];

      const reader = new FileReader();
      reader.onload = () => this.imagePreview = reader.result;
      reader.readAsDataURL(this.selectedFile);
    }
  }

  onUpload() {
    if (this.form.invalid) return;

    const formData = new FormData();
    formData.append('file',  this.selectedFile); 

    this.restService.imageCompany(this.data.company.id, formData).subscribe({
      next: res => {
          this.dialogRef.close({ updated: true }); 
          this.appService.showSuccessToast(Constants.MSG_SUCCESS);
        }
    });
  }

   delete(): void {
    if (!confirm('¿Está seguro de eliminar este descuento?')) return;
    const id:number = this.form.value.id;
    this.restService.deleteCompany(id).subscribe({
      next: res => {
          this.dialogRef.close({ updated: true }); 
          this.appService.showSuccessToast(Constants.MSG_SUCCESS);
        }
    });
  }

  private prepareCompany() {
    const value = this.form.value;
    return {
      ...value
    };
  }

}